import { Button, Empty } from "antd";
import qs from "qs";
import request from "../../../../../../utils/request";
import { CommonStaticTable } from "../CommonTable";
export const audits = [
  {
    label: "无",
    value: 0,
  },
  {
    label: "事前审计",
    value: 1,
  },
  {
    label: "事后审计",
    value: 2,
  },
];
export const BiddingOptions = [
  { label: "公开招标", value: "0", fullLabel: "公开招标" },
  {
    label: "竞争性谈判",
    options: [
      { label: "最低价中标", value: "1", fullLabel: "竞争性谈判 / 最低价中标" },
      { label: "摇号", value: "2", fullLabel: "竞争性谈判 / 摇号" },
    ],
  },
  { label: "竞争性磋商", value: "3", fullLabel: "竞争性磋商" },
  {
    label: "小额谈判",
    options: [
      { label: "最低价中标", value: "4", fullLabel: "小额谈判 / 最低价中标" },
      { label: "摇号", value: "5", fullLabel: "小额谈判 / 摇号" },
    ],
  },
  { label: "其他", value: "6", fullLabel: "其他" },
];
export const engineer = {
  key: "engineer",
  config: {
    name: "批而未供土地",
    title: "批而未供",
    tabs(data: any) {
      const items = [
        {
          key: "2",
          label: `前期准备`,
          panels() {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "调研设计——附件", // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down1 && data.down1.length) {
                        return data.down1.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                  {
                    span: "12",
                    label: "项目备案——附件", // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down2 && data.down2.length) {
                        return data.down2.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "3",
          label: `招标信息`,
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "招标方式",
                    value: () => {
                      let label: any = "-";
                      BiddingOptions.forEach((op) => {
                        if (data.zb_type === op.value) {
                          label = op.fullLabel;
                        } else {
                          if (Array.isArray(op.options)) {
                            op.options.forEach((it) => {
                              if (data.zb_type === it.value) {
                                label = it.fullLabel;
                              }
                            });
                          }
                        }
                      });
                      return label;
                      // return data.zb_type || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "代理公司",
                    value: () => {
                      return data.dl_company || "-";
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "4",
          label: `合同信息`,
          isSub: true,
          panels(data: any) {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "建设单位",
                    value: () => {
                      const jsCompanyOptons = [
                        {
                          label: "马鞍山雨山经济开发区管委会",
                          value: "1",
                        },
                        {
                          label: "马鞍山雨山经济开发区发展有限公司",
                          value: "2",
                        },
                      ];
                      const tItem =
                        jsCompanyOptons.find(
                          (item) => item.value == data.js_company
                        ) || ({} as any);
                      return tItem.label || data.js_company || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "施工单位",
                    value: () => {
                      return data.sg_company || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "签订时间",
                    value: () => {
                      return data.ht_time || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "合同金额（元）",
                    value: () => {
                      return (data.ht_price || "-") + "元";
                    },
                  },
                  {
                    span: "12",
                    label: "项目经理",
                    value: () => {
                      return data.ht_fzr || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "联系方式",
                    value: () => {
                      return data.ht_mobile || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "开工时间",
                    value: () => {
                      return data.ht_stime || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "竣工时间",
                    value: () => {
                      return data.ht_etime || "-";
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "5",
          label: `变更信息`,
          panels() {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "24",
                    label: "变更原因",
                    value: () => {
                      return data.reason || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件信息";
                },
                items: [
                  {
                    span: "24",
                    label: "附件信息", // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down5 && data.down5.length) {
                        return data.down5.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "6",
          label: `项目实况`,
          panels() {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "实际开工时间",
                    value: () => {
                      return data.real_stime || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "实际竣工时间",
                    value: () => {
                      return data.real_etime || "-";
                    },
                  },
                  {
                    span: "24",
                    label: "监控视频拉流地址",
                    value: () => {
                      return data.urls || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件信息";
                },
                items: [
                  {
                    span: "24",
                    label: "附件信息", // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down6 && data.down6.length) {
                        return data.down6.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "custom", // 针对地图,附件特殊标记
                    value: () => {
                      // return <ProjectLiveImages id={data.id} enableEdit={false} />;
                      return (
                        <Empty description={<span>TODOS(建设照片)</span>} />
                      );
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "7",
          label: `竣工备案`,
          panels() {
            return [
              {
                title: () => {
                  return "附件信息";
                },
                items: [
                  {
                    span: "24",
                    label: "附件信息", // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down7 && data.down7.length) {
                        return data.down7.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "8",
          label: `审计信息`,
          panels() {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "审计类型",
                    value: () => {
                      const ad: any = audits.find(
                        (item) => item.value == data.sj_type
                      );
                      return ad.label || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "审计单位",
                    visiable: () => {
                      return data.sj_type != 0;
                    },
                    value: () => {
                      return data.sj_company || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "联系人",
                    visiable: () => {
                      return data.sj_type != 0;
                    },
                    value: () => {
                      return data.sj_people || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "联系电话",
                    visiable: () => {
                      return data.sj_type != 0;
                    },
                    value: () => {
                      return data.sj_mobile || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "送审时间",
                    visiable: () => {
                      return data.sj_type != 0;
                    },
                    value: () => {
                      return data.sj_time || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "审定额（元）",
                    visiable: () => {
                      return data.sj_type != 0;
                    },
                    value: () => {
                      return data.sj_money || "-";
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "附件信息";
                },
                visiable: () => {
                  return data.down8 && data.down8.length;
                },
                items: [
                  {
                    span: "24",
                    // label: '', // 有label 设置 label,
                    componentType: "file", // 针对地图,附件特殊标记
                    value: () => {
                      if (data.down8 && data.down8.length) {
                        return data.down8.map((file: any) => {
                          return {
                            uid: file.id,
                            name: file.title,
                            url: file.urls,
                          };
                        });
                      }
                      return [];
                    },
                  },
                ],
              },
              {
                title: () => {
                  return "";
                },
                items: [
                  {
                    span: "12",
                    label: "审计单位",
                    visiable: () => {
                      return data.sj_type != 0 && data.is_follow;
                    },
                    value: () => {
                      return data.sj_money || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "联系人",
                    visiable: () => {
                      return data.sj_type != 0 && data.is_follow;
                    },
                    value: () => {
                      return data.sj_follow_people || "-";
                    },
                  },
                  {
                    span: "12",
                    label: "联系电话",
                    visiable: () => {
                      return data.sj_type != 0 && data.is_follow;
                    },
                    value: () => {
                      return data.sj_follow_mobile || "-";
                    },
                  },
                ],
              },
            ];
          },
        },
        {
          key: "9",
          isSub: true,
          label: `付款信息`,
          panels() {
            return [
              {
                title: () => {
                  return "";
                },
                items: [
                  // <Empty description={<span>TODOS</span>} />,
                  {
                    span: "24",
                    componentType: "custom",
                    value: () => {
                      const columns = [
                        {
                          title: "批次",
                          dataIndex: "number",
                          hideInSearch: true,
                        },
                        {
                          title: "付款金额（万元）",
                          dataIndex: "money",
                          hideInSearch: true,
                        },
                        {
                          title: "状态",
                          dataIndex: "ispay",
                          hideInSearch: true,
                          render(value: any) {
                            return value === 0 ? "未付款" : "已付款";
                          },
                        },
                        {
                          title: "资金来源",
                          dataIndex: "comfrom",
                          hideInSearch: true,
                          // render(value) {
                          //   return options.find(item => item.value === +value)?.label || value;
                          // },
                        },
                        {
                          title: "付款时间",
                          dataIndex: "pay_time",
                          hideInSearch: true,
                        },
                        {
                          title: "确认人",
                          dataIndex: "people",
                          hideInSearch: true,
                          // render(value) {
                          //   return options.find(item => item.value === +value)?.label || value;
                          // },
                        },
                        {
                          title: "备注",
                          dataIndex: "desc",
                          hideInSearch: true,
                        },
                        {
                          title: "付款凭证",
                          dataIndex: "file_title",
                          hideInSearch: true,
                          render(value: any, record: any) {
                            return (
                              <Button
                                type="link"
                                target="_blank"
                                href={record.file_urls}
                              >
                                {value}
                              </Button>
                            );
                          },
                        },
                      ];
                      return (
                        <CommonStaticTable
                          columns={columns}
                          dataSource={data.payment}
                        />
                      );
                    },
                  },
                ],
              },
            ];
          },
        },
      ];
      const isSub = data.cat_par_id !== 0;
      if (isSub) {
        return items.filter((item: any) => item.isSub);
      }
      return items;
    },
    panels: (opts = {} as any) => {
      const { type, data } = opts;
      return [
        {
          title: () => {
            return data.title;
          },
          panels: [
            {
              title: () => {
                return "基本信息";
              },
              items: [
                {
                  span: "12",
                  label: "工程名称",
                  value: () => {
                    return data.title || "-";
                  },
                },
                {
                  span: "12",
                  label: "工程类型",
                  value: () => {
                    return data.cat_name || "-";
                  },
                },
                {
                  span: "12",
                  label: "主工程",
                  visiable: () => {
                    return data.par_id;
                  },
                  value: () => {
                    return data.par_id || "-";
                  },
                },
                {
                  span: "12",
                  label: "经办人",
                  value: () => {
                    return data.people || "-";
                  },
                },
              ],
            },
            // {
            //   title: () => {
            //     return "前期准备";
            //   },
            //   items: [
            //     {
            //       span: "12",
            //       label: "调研设计——附件",
            //       labelStyle: { display: "block" },
            //       value: () => {
            //         return (data.down1 || []).map((file: any) => {
            //           return <a href={file.urls}> {file.title}</a>;
            //         });
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "项目备案——附件",
            //       labelStyle: { display: "block" },
            //       value: () => {
            //         return (data.down2 || []).map((file: any) => {
            //           return <a href={file.urls}> {file.title}</a>;
            //         });
            //       },
            //     },
            //   ],
            // },
            // {
            //   title: () => {
            //     return "招标信息";
            //   },
            //   items: [
            //     {
            //       span: "12",
            //       label: "招标方式",
            //       value: () => {
            //         return data.zb_type || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "代理公司",
            //       value: () => {
            //         return data.dl_company || "-";
            //       },
            //     },
            //   ],
            // },
            // {
            //   title: () => {
            //     return "合同信息";
            //   },
            //   items: [
            //     {
            //       span: "12",
            //       label: "建设单位",
            //       value: () => {
            //         const jsCompanyOptons = [
            //           {
            //             label: "马鞍山雨山经济开发区管委会",
            //             value: "1",
            //           },
            //           {
            //             label: "马鞍山雨山经济开发区发展有限公司",
            //             value: "2",
            //           },
            //         ];
            //         const tItem =
            //           jsCompanyOptons.find(
            //             (item) => item.value == data.js_company
            //           ) || ({} as any);
            //         return tItem.label || data.js_company || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "施工单位",
            //       value: () => {
            //         return data.sg_company || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "签订时间",
            //       value: () => {
            //         return data.ht_time || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "合同金额（元）",
            //       value: () => {
            //         return (data.ht_price || "-") + "元";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "项目经理",
            //       value: () => {
            //         return data.ht_fzr || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "联系方式",
            //       value: () => {
            //         return data.ht_mobile || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "开工时间",
            //       value: () => {
            //         return data.ht_stime || "-";
            //       },
            //     },
            //     {
            //       span: "12",
            //       label: "竣工时间",
            //       value: () => {
            //         return data.ht_etime || "-";
            //       },
            //     },
            //   ],
            // },
          ],
        },
      ];
    },
    table: {
      pageSize: 10,
      async list(body: any) {
        // https://apiv2.wxstores.cn/screen/Other/getEngineering?type=0&years=2022&page=1&keys=
        const url = `/screen/Other/getEngineering`;
        // 需要针对Parms 进行处理
        const res = await request.get(url + "?" + qs.stringify(body));
        return res.data.data;
      },

      columns: (opts = {} as any) => {
        const { setSwitchDetail, type, tableParams } = opts;
        const base = {
          title: "序号",
          dataIndex: "",
          align: "center",
          render(_value: any, _record: any, index: number) {
            const { current = 1, pageSize = 10 } = tableParams.pagination;
            return index + 1 + (current - 1) * pageSize;
          },
        };
        return [
          base,
          {
            title: "工程名称",
            align: "center",
            dataIndex: "title",
            render(_value: any, _record: any, index: number) {
              return (
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSwitchDetail?.(_record);
                  }}
                >
                  {_value}
                </div>
              );
            },
          },
          {
            title: "工程类型",
            align: "center",
            dataIndex: "type",
            render(_value: any, _record: any, index: number) {
              return _value;
            },
          },
          {
            title: "经办人",
            align: "center",
            dataIndex: "people",
          },
        ];
      },
    },
  },
} as any;
